"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var HeadModule_exports = {};
__export(HeadModule_exports, {
  HeadModule: () => HeadModule
});
module.exports = __toCommonJS(HeadModule_exports);
var _globalThis_expo_modules;
var _globalThis_expo;
var HeadModule = null;
if (typeof expo !== "undefined" && ((_globalThis_expo = globalThis.expo) === null || _globalThis_expo === void 0 ? void 0 : (_globalThis_expo_modules = _globalThis_expo.modules) === null || _globalThis_expo_modules === void 0 ? void 0 : _globalThis_expo_modules.ExpoGo)) {
  var _globalThis_expo_modules1, _globalThis_expo1;
  HeadModule = (_globalThis_expo1 = globalThis.expo) === null || _globalThis_expo1 === void 0 ? void 0 : (_globalThis_expo_modules1 = _globalThis_expo1.modules) === null || _globalThis_expo_modules1 === void 0 ? void 0 : _globalThis_expo_modules1.HeadModule;
}
//# sourceMappingURL=HeadModule.js.map
